if (!customElements.get('quote-cart-notification')) {
  class QuoteCartNotification extends HTMLElement {
    constructor() {
      super();

      // elements
      this.popup = this.querySelector('pop-up');

      // event listeners
      document.addEventListener('quote-added', this.togglePopup.bind(this));
    }

    /**
     * Toggle the popup
     */
    togglePopup() {
      this.popup.classList.add('popup-is-open');
      document.body.classList.add('popup-is-open');
    }
  }

  window.QuoteCartNotification = QuoteCartNotification;
  customElements.define('quote-cart-notification', QuoteCartNotification);
}
